import { gql } from '$lib/apollo';

export const EDIT_CALENDAR = gql`
  mutation EditGoogle($input: GoogleEditInput!) {
    googleEdit(input: $input) {
      result {
        id
        email
        isCalendarLinked
        calendarAdd
        calendarConflicts
      }
    }
  }
`;
